import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiCamera, FiMessageCircle, FiCheckSquare, FiClock } = FiIcons;

const steps = [
  {
    num: "01",
    icon: FiCamera,
    title: "Scatta le foto",
    desc: "Fotografa gli ambienti da sgomberare e i mobili in buono stato."
  },
  {
    num: "02",
    icon: FiMessageCircle,
    title: "Invia su WhatsApp",
    desc: "Mandaci tutto con un messaggio. È veloce, diretto e senza impegno."
  },
  {
    num: "03",
    icon: FiCheckSquare,
    title: "Ricevi valutazione",
    desc: "Ti diciamo subito quanto vale il tuo usato e il costo finale."
  }
];

export default function HowItWorks() {
  return (
    <section className="py-20 md:py-24 bg-[#0A0A0A] border-y border-white/5">
      <div className="container mx-auto px-5">
        
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 md:mb-16 gap-6">
          <motion.h2 
            className="text-4xl sm:text-5xl md:text-7xl font-display uppercase italic leading-none"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            BASTANO <br/><span className="text-maaich-lime">3 FOTO.</span>
          </motion.h2>
          
          <motion.div 
            className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-full px-5 py-2 md:px-6 md:py-3 self-start md:self-auto"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <SafeIcon icon={FiClock} className="text-maaich-lime text-lg md:text-xl" />
            <span className="font-display uppercase italic tracking-wider text-sm md:text-base">Meno di 5 minuti</span>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 relative">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-[1px] bg-white/10 z-0"></div>

          {steps.map((step, index) => (
            <motion.div 
              key={index}
              className="relative z-10 flex flex-col items-center text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
            >
              <div className="w-20 h-20 md:w-24 md:h-24 bg-maaich-black border-2 border-maaich-lime rounded-full flex items-center justify-center mb-5 md:mb-6 relative group">
                <span className="absolute -top-3 -left-3 md:-top-4 md:-left-4 text-3xl md:text-4xl font-display text-white/20">{step.num}</span>
                <SafeIcon icon={step.icon} className="text-2xl md:text-3xl text-maaich-lime group-hover:scale-110 transition-transform" />
              </div>
              <h3 className="text-xl md:text-2xl font-display uppercase italic mb-2">{step.title}</h3>
              <p className="text-white/60 font-body font-light text-sm md:text-base px-4 md:px-0">{step.desc}</p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}